import React from 'react';

import shopify from '../../../utils/shopify';

import BasePage from '../BasePage';
import Navigation from '../../../components/Site/Navigation';
import ShopFooter from '../../../components/Site/Shop/ShopFooter';

import Cart from '../../../components/Site/Shop/Cart';
import Gallery from '../../../components/Site/Shop/Gallery';

class Shop extends BasePage {
	constructor() {
		super();

		this.state = {
			featuredStickers: [],
			catStickers: [],
			petStickers: [],
			stickers: [],
			cart: null,
		};

		this.activePromo = false;

		this.shopClosedUntilDate = null;
		this.shopClosedMessage = <div>We’ll be back on {this.shopClosedUntilDate}.<br />Thanks for your support!</div>;

		this.updateCart = this.updateCart.bind(this);
	}

	componentDidMount() {
		shopify.getCurrentStock.then((stickersFromShopify) => {
			this.setState({ stickers: stickersFromShopify });
		});

		shopify.getCart.then((cartFromShopify) => {
			this.setState({ cart: cartFromShopify });
		});

		window.scrollTo(0, 0);
	}

	updateCart(cartObject) {
		this.setState({ cart: cartObject });
	}

	render() {
		return (
			<div className="section section--centered section--shop bg--orange">

				<div className="shop__intro">
					<Navigation />

					<div className="intro__header">
						<h1>Tabby Cat Shop</h1>
						{/* <p>Mystery kitty packs are here!</p> */}
					</div>

					<div className="intro__disclaimer">
						{!this.shopClosedUntilDate && (
							''
						)}
					</div>
				</div>

				{this.shopClosedUntilDate && (
					<div className="closed-banner">
						<div className="closed-banner__inner">
							<svg width="60" height="60" viewBox="0 0 60 60">
								<polygon points="42.7232857,18.2530651 40.279438,18.2530651 42.7232857,14.747694 42.7232857,12.8526745 36.9850044,12.8526745
									36.9850044,15.1754284 39.317524,15.1754284 36.958149,18.6837292 36.958149,20.575819 42.7232857,20.575819 " />
								<polygon points="34.9098091,24.1495495 32.4659615,24.1495495 34.9098091,20.6441784 34.9098091,18.7491589
									29.1715279,18.7491589 29.1715279,21.0719128 31.5040474,21.0719128 29.1446724,24.5802135 29.1446724,26.4723034
									34.9098091,26.4723034 " />
								<circle cx="30.0000191" cy="39.8555412" r="2.7578125" />
								<path d="M44.4181099,32.2667351c-1.019043,1.2397461-2.5219727,1.9506836-4.1245117,1.9506836
									s-3.105957-0.7109375-4.1245117-1.9511719l-2.3183594,1.9042969c1.5908203,1.9365234,3.9389648,3.046875,6.4428711,3.046875
									c2.503418,0,4.8515625-1.1103516,6.4418945-3.0463867L44.4181099,32.2667351z" />
								<path d="M19.7066841,34.2174187c-1.6025391,0-3.105957-0.7109375-4.1245127-1.9511719l-2.3183594,1.9042969
									c1.5908203,1.9365234,3.9389658,3.046875,6.442872,3.046875c2.503418,0,4.8520508-1.1103516,6.4423828-3.0463867
									l-2.3173828-1.9042969C22.8126411,33.5064812,21.3092232,34.2174187,19.7066841,34.2174187z" />
							</svg>
							<div className="closed-banner__header">
								The shop is taking a little break.
							</div>
							<div className="closed-banner__desc">
								{this.shopClosedMessage}
							</div>
						</div>
					</div>
				)}

				{this.activePromo && (
					<div className="promo-banner">
						<div className="promo-banner__inner">
							<div className="promo-banner__header">
								Free shipping on orders over $15!
							</div>
							<div className="promo-banner__desc">
								Valid on US orders with code: <div className="promo-banner__code">SHIPPY-CAT</div>
							</div>
						</div>
					</div>
				)}

				<Gallery shopClosedUntilDate={this.shopClosedUntilDate} products={this.state.stickers} cart={this.state.cart} updateCart={this.updateCart} />

				<ShopFooter />

				{!this.shopClosedUntilDate && (
					<Cart cart={this.state.cart} updateCart={this.updateCart} />
				)}

			</div>
		);
	}
}

export default Shop;



// WEBPACK FOOTER //
// ./src/routes/Site/Shop/index.js